(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aim-header-utility"] && !Shopify.designMode) return;
  try {
    // Native details handles click, touch and keyboard. Mouse users can also hover.
  const discoverFor = node => node.closest?.('.aim-discover');
  let hoverOnly = null;
  document.addEventListener('pointerover', e => {
    const menu = discoverFor(e.target);
    if (e.pointerType !== 'mouse' || !menu || menu.contains(e.relatedTarget) || menu.open) return;
    menu.open = true;
    hoverOnly = menu;
  });
  document.addEventListener('pointerout', e => {
    const menu = discoverFor(e.target);
    if (menu && menu === hoverOnly && !menu.contains(e.relatedTarget)) {
      if (!menu.contains(document.activeElement)) menu.open = false;
      hoverOnly = null;
    }
  });
  document.addEventListener('click', e => {
    const menu = document.querySelector('.aim-discover[open]');
    if (!menu) return;
    if (!menu.contains(e.target)) menu.open = false;
    else if (hoverOnly === menu && e.target.closest('summary')) e.preventDefault();
    hoverOnly = null;
  });
  document.addEventListener('focusin', e => {
    const menu = document.querySelector('.aim-discover[open]');
    if (menu && !menu.contains(e.target)) { menu.open = false; hoverOnly = null; }
  });
  document.addEventListener('keydown', e => {
    const menu = document.querySelector('.aim-discover[open]');
    if (e.key === 'Escape' && menu) {
      menu.open = false; hoverOnly = null;
      if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
